import {
  IssueSubtypeDto,
  UpdateIssueSubtypeRequestDto,
  useApi,
} from '@issuemanager/api-client';
import { ExtendedAxiosError } from '@issuemanager/apps/client/hooks';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useUpdateIssueSubtype(): ReturnType<
  typeof useMutation<
    IssueSubtypeDto,
    ExtendedAxiosError,
    { id: string } & UpdateIssueSubtypeRequestDto
  >
> {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation<
    IssueSubtypeDto,
    ExtendedAxiosError,
    { id: string } & UpdateIssueSubtypeRequestDto
  >({
    mutationKey: ['issue-subtypes'],
    mutationFn: ({ id, ...data }) =>
      api.issueSubtypesApi
        .updateIssueSubtype(id, { ...data })
        .then((r) => r.data),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['users', 'roles'],
      });
    },
  });
}
